import { CheckCircle2, OctagonAlert } from "lucide-react";

/**
 * READINESS STRIP — the honest answer to "how ready is this document, and what's left?"
 *
 * Composed from REAL signals, never a fabricated percentage or progress bar (qa.ts doctrine +
 * CLAUDE.md: never strengthen certainty). protectedFactsClear is the ONE hard blocker; advisories
 * and reviewer concerns never turn it red. It states the composite AND the one thing standing
 * between here and export.
 */
export function ReadinessStrip({
  protectedFactsClear,
  checksPassed,
  checksTotal,
  blocking,
  advisoriesOpen,
  decided,
  total
}: {
  protectedFactsClear: boolean;
  checksPassed: number;
  checksTotal: number;
  blocking: number;
  advisoriesOpen: number;
  decided: number;
  total: number;
}) {
  const ready = protectedFactsClear && blocking === 0;
  const facts: string[] = [
    protectedFactsClear ? "Protected facts clear" : "Protected-fact issue",
    `${checksPassed}/${checksTotal} checks passed`,
    `${blocking} blocking`,
    `${advisoriesOpen} advisory${advisoriesOpen === 1 ? "" : "ies"} open`,
    `${decided}/${total} edits decided`
  ];
  const nextStep = !protectedFactsClear
    ? "Fix the protected-fact issue to export."
    : blocking > 0
      ? "Clear the blocking check to export."
      : advisoriesOpen > 0
        ? `Nothing blocks export — ${advisoriesOpen} advisory suggestion${advisoriesOpen === 1 ? "" : "s"} you can address or export past.`
        : "Nothing — ready to download or send.";

  return (
    <section className="readiness" data-ready={ready ? "true" : "false"} data-testid="readiness-strip">
      <div className="readiness-head">
        <span className="readiness-glyph" aria-hidden="true">
          {ready ? <CheckCircle2 /> : <OctagonAlert />}
        </span>
        <strong className="readiness-verdict">{ready ? "Ready to export" : "Not ready to export"}</strong>
      </div>
      <ul className="readiness-facts">
        {facts.map((fact) => (
          <li key={fact}>{fact}</li>
        ))}
      </ul>
      <p className="readiness-next">
        <span className="readiness-next-label">What's left:</span> {nextStep}
      </p>
    </section>
  );
}
